import React from "react";
import Sidebar from "../components/Sidebar";

function CloudSync() {
  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="main-content">
        <h2>Cloud Sync</h2>
      </div>
    </div>
  );
}

export default CloudSync;